export var ResponseType;

(function (ResponseType) {
  ResponseType["All"] = "all";
  ResponseType["Summary"] = "summary";
})(ResponseType || (ResponseType = {}));